import { BREAKPOINTS } from "layout";
import styled from "styled-components";

export const CustomPoints = styled.div`
  border-radius: 4px;
  background: #f9f9fa;
  padding: 24px;
  max-width: 440px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
  }
`;

export const Description = styled.span`
  color: #808893;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const Header = styled.span`
  color: #3b3f45;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin-top: 24px;
`;

export const PointsContainer = styled.div`
margin-top: 8px;
`;

export const CopyContainer = styled.div``;

export const Category = styled.b`
  color: #676F79;
  font-weight: 900px;
  line-height: 26px;
`;

export const QualifiedProducts = styled.span`
  color: #808893;
`;
